export default __webpack_public_path__ + "static/media/121.4786f86b.jpg";